import { useEffect, useState } from 'react'

export default function () {
  const [switchedUser, setSwitchedUser] = useState(null)

  useEffect(() => {
    setSwitchedUser(localStorage.getItem('su'))
  }, [])

  const switchUser = (email) => {
    setSwitchedUser(email)
    localStorage.setItem('su', email)
    global.location.reload()
  }

  const dropSwitchedUser = () => {
    localStorage.removeItem('su')
    global.location.reload()
  }

  return {
    switchedUser,
    switchUser,
    dropSwitchedUser,
  }
}
